import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHead, Carousel, TestimonialCard } from '../ui';
import { TESTIMONIALS } from '../../data/home';

export default function Testimonials() {
  const { t } = useTranslation();
  return (
    <div className="testimonials">
      <SectionHead eyebrow={t('Pilgrim Stories')} title={t('What Devotees Say')} />
      <Carousel ariaLabel={t('Testimonials')} itemWidth={360} gap={16} showDots={false}>
        {TESTIMONIALS.map((x) => <TestimonialCard key={x.name} {...x} text={t(x.text)} />)}
      </Carousel>
    </div>
  );
}
